import './CCBlurb.css';
import creativeCalisthenics from '../../assets/images/creativeCalisthenics.png';
import React from "react";

function CCBlurb(props) {
    return (
        <div>
            <img className="creativeCalisthenicsImg" src={creativeCalisthenics} alt="introducing creative calisthenics" />
            <p className="ccBlurbText">
                In a world where AI can "generate" (read: copy and regurgitate) anything with a click of a button, your individual creativity is more important than ever. Creative Calisthenics is an interactive program designed to boost your imagination and spark collaboration. We have options for everyone, even those with absolutely no art or design experience.
            </p>
            <div className="ccBlurbButton">
                <a className="href" href="/creative-calisthenics">
                    <p className="ccButtonText"> learn more</p>
                </a>
            </div>
        </div>
    )
}

export default CCBlurb;